import { render, staticRenderFns } from "./updateCourtOrder.vue?vue&type=template&id=331e1147&scoped=true&"
import script from "./updateCourtOrder.vue?vue&type=script&lang=js&"
export * from "./updateCourtOrder.vue?vue&type=script&lang=js&"
import style0 from "./updateCourtOrder.vue?vue&type=style&index=0&id=331e1147&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e1147",
  null
  
)

export default component.exports